import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const GIFT_CURRENCIES = ['GEL', 'USD', 'EUR']

const CURRENCY_SYMBOLS = { GEL: '₾', USD: '$', EUR: '€' }

export function currencySymbol(code) {
  return CURRENCY_SYMBOLS[code] || CURRENCY_SYMBOLS.GEL
}

/**
 * Format a numeric money value with thousands separators and exactly two
 * decimals — 1234.5 → "1,234.50", 1234567.8 → "1,234,567.80". Grouping is
 * fixed to the "xxx,xxx,xxx.xx" style (comma groups, dot decimal) regardless
 * of UI language. Accepts numbers or numeric strings; non-numeric input falls
 * back to "0.00". The currency symbol/code is applied by the caller.
 */
export function formatMoney(value) {
  const n = Number(value)
  return (Number.isFinite(n) ? n : 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function getApiUrl() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim()

  if (!backendUrl) {
    return '/api'
  }

  const normalizedBackendUrl = /^https?:\/\//i.test(backendUrl)
    ? backendUrl
    : `https://${backendUrl}`

  return `${normalizedBackendUrl.replace(/\/$/, '')}/api`
}

export function resolveImageUrl(imageUrl) {
  if (!imageUrl) {
    return ''
  }

  if (
    /^https?:\/\//i.test(imageUrl) ||
    imageUrl.startsWith('data:') ||
    imageUrl.startsWith('blob:')
  ) {
    return imageUrl
  }

  const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim()

  if (backendUrl) {
    const normalizedBackendUrl = /^https?:\/\//i.test(backendUrl)
      ? backendUrl
      : `https://${backendUrl}`

    return `${normalizedBackendUrl.replace(/\/$/, '')}${imageUrl}`
  }

  return `${window.location.origin}${imageUrl}`
}
